import { useEffect, useState } from "react";
import { getPointOfSaleOffers } from "../../common/services/externalService";
import langs from "../../common/services/languageService";
import PointsOfSaleFilter from "./points-of-sale-filter/points-of-sale-filter";
import PointsOfSaleMap from "./points-of-sale-map/points-of-sale-map";

const { labels } = langs;

function PointsOfSale({ mapSiteConfigKey = "default" }) {
  const [selectedOfferFilter, setSelectedOffer] = useState();
  const [posOffers, setPosOffers] = useState([]);
  const [regulationFileUrl, setRegulationFileUrl] = useState(null);

  useEffect(() => {
    getPointOfSaleOffers(mapSiteConfigKey).then((response) => {
      setRegulationFileUrl(response.data.regulationFileUrl);
      setPosOffers(response.data.offerKeys);
    });
  }, []);

  return (
    <div className="ploom-no-offer">
      <div className="ploom-no-offer__header">
        <p>{labels.OfferMapTitle()}</p>
        <p className="bold">{labels.Ploom()}</p>
      </div>
      <PointsOfSaleMap
        mapSiteConfigKey={mapSiteConfigKey}
        selectedOfferFilter={selectedOfferFilter}
      />
      <PointsOfSaleFilter
        posOffers={posOffers}
        onFilterByOffer={setSelectedOffer}
        selectedOfferFilter={selectedOfferFilter}
      />
      <a
        href={regulationFileUrl}
        target="_blank"
        rel="noopener"
        style={{ textAlign: "right" }}
      >
        {labels.ProgramRegulations()}
      </a>
    </div>
  );
}

export default PointsOfSale;
